import PaymentService from '@/api/PaymentService'

// initial state
const state = {
  payments: [],
  payment: null,
  nextPeCode: null,
}

// getters
const getters = {
  getPayments: state => state.payments,
  getPayment: state => state.payment,
  getNextPeCode: state => state.nextPeCode,
  getPercentageOfPayment: (state) => (payments, grandtotal) => {
    let paidTotal = 0
    for (let i in payments) {
      let p = payments[i]
      if (p.status == 'paid') {
        paidTotal += p.payment.amount
      }
    }
    return (paidTotal * 100 / grandtotal).toFixed(2)
  },
  getPaymentStatus: (state) => (payment, $t) => {
    if (payment.status == 'padding') {
      return {
        message: $t('status.pe.unpaid'),
        status: 'uncompleted',
      }
    }
    return {
      message: $t('status.pe.paid'),
      status: 'completed',
    }
  },
}

// mutations
const mutations = {
  setPayments (state, data) {
    state.payments = data
  },
  setPayment (state, data) {
    state.payment = data
  },
  setNextPoCode (state, data) {
    state.nextPeCode = data
  },
  updatePaymentStatus (state, data) {
    if (state.payment) {
      if (state.payment.pe_id == data.pe_id) {
        state.payment.status = data.status
      }
    }
    if (state.payments.length > 0) {
      state.payments.map((p, idx) => {
        if (p.pe_id == data.pe_id) {
          return p.status = data.status
        }
      })
    }
  },
}

// actions
const actions = {
  async getPayments ({ commit }, params) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPayments') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPayments')

      let response = await PaymentService.getAll(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPayments')

      result = response.data

      if (result.success) {
        commit('setPayments', result.data)
        this.dispatch('setPagination', result.meta)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearPayments ({ commit }) {
    commit('setPayments', [])
  },
  async getPayment ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPayment') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPayment')

      let response = await PaymentService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPayment')

      result = response.data

      if (result.success) {
        if (result.data.length > 0) {
          commit('setPayment', result.data[0])
        } else {
          // not found data
          this.dispatch('Error', 'Not found data')
        }
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearPayment ({ commit }) {
    commit('setPayment', null)
  },
  async insertPayment ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      const response = await PaymentService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        // success
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getNextPeCode ({ commit }) {
    var result = null

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getNextPeCode') >= 0) return

    try {
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getNextPeCode')

      let response = await PaymentService.getLatestCode()

      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getNextPeCode')

      result = response.data

      if (result.success) {
        commit('setNextPoCode', result.data.next)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deletePayment ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await PaymentService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updatePayment ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await PaymentService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updatePaymentStatus ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await PaymentService.updateStatus(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        commit('updatePaymentStatus', data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Payment.js